import { Avatar, Box, Button, Typography } from '@mui/material'

export const Design = ({handlerChange, marketing_camp}) => {
    const { form, custom } = marketing_camp
    const inputs = form.data
    
    const handlerChangeColor = (e) => {
        const { value, name } = e.target
        form.set({...form.data, [name]: value})
    }
    
    return (
        <Box display="flex" flexDirection="column" gap="16px">
            <Typography fontWeight={600}>Background Image</Typography>
            <Box display="flex" flexDirection="column" alignItems="center" gap="16px">
                <Avatar variant="square" src={inputs.bg_image.object === "" ? inputs.bg_image.value : inputs.bg_image.object} alt="background-img" 
                    sx={{width: 120, height: 120 }}
                />
                <label htmlFor='bg_image'>
                    <Button variant='contained' component="span" 
                        sx={{
                            bgcolor: '#f0f0f0',
                            color: '#000',
                            '&:hover': { bgcolor: '#e0e0e0' },
                        }}
                    >
                        Upload Image
                    </Button>
                </label>
                <input type='file' accept="image/*" id="bg_image" name="bg_image" hidden onChange={handlerChange} />
            </Box>
            {
                custom.data !== '' &&
                    <>
                        <Typography fontWeight={600}>Text Color</Typography>
                        <input type="color" value={inputs[custom.data] || '#000000'} name={custom.data} onChange={handlerChangeColor} />
                    </>
            }
            {
                custom.data === 'qualification_text_color' &&
                    <>
                        <Typography fontWeight={600}>Background Color</Typography>
                        <input type="color" value={inputs.qualification_bg} name="qualification_bg" onChange={handlerChangeColor} />
                    </>
            }
        </Box>
    )
}
